import React from 'react';

import { Typography } from 'ha/ui/next/Typography';
import Link from 'ha/ui/next/Link';
import Grid from 'ha/ui/next/Grid';

interface Props {
  text: React.ReactNode;
  url?: string;
  renderAsLink: boolean;
}

const BreadcrumbItem: React.FC<Props> = ({ text, url, renderAsLink }) => {
  const isLink = renderAsLink && url;

  const textElement = (
    <Typography.Caption
      color={isLink ? 'default' : 'muted'}
      fontWeight={isLink ? 'bold' : 'normal'}
    >
      <Grid container>{text}</Grid>
    </Typography.Caption>
  );

  return isLink ? <Link to={url!}>{textElement}</Link> : textElement;
};

export default BreadcrumbItem;
